import type {
	SnippetBodyFormat,
	SnippetProduct,
	SnippetScope,
	SnippetStatus,
} from '../snippetTypes.ts';

export class SnippetError extends Error {
	constructor(message: string) {
		super(`Snippet error: ${message}`);
	}
}

export type SnippetData = {
	resourceId: string; // ARI of the Snippet
	snippetId: string;
	name: string; // User defined name
	description?: string; // User defined name
	body: string; // String of the type defined in `bodyFormat` (example: "ADF")
	bodyFormat: SnippetBodyFormat;
	product: SnippetProduct;
	label?: string;
	isFavorite: boolean;
	status: SnippetStatus;
	/** Scope returned by the backend. Used for UI; not sent on create/update. */
	scope: SnippetScope;
	createdBy: string;
	createdAt: string; // String of integer timestamp
	updatedAt: string; // String of integer timestamp
	usageCount?: number;
};

/** Payload for creating or updating a snippet */
export type CreateSnippetPayload = {
	name: string;
	body: string;
	bodyFormat: SnippetBodyFormat;
	product: SnippetProduct;
	description?: string;
};

export type UpdateSnippetPayload = {
	name: string;
	body: string;
	description?: string;
};

export type SnippetFavoriteData = {
	userId: string;
	snippetIds: string[]; // Array of snippet ARIs
};
